import lazyWithReload from '../../utils/lazyWithReload';
import createRecordDrawer from './createRecordDrawer';

const CrmContactDrawer = lazyWithReload(() => import('./CrmContactDrawer'), 'CrmContactDrawer');

/**
 * CrmContactDrawerContext — URL-driven global contact drawer.
 * Source of truth: query param `?contactId=<short>`.
 *
 * API: useCrmContactDrawer() → { openContact, closeContact, version, bumpVersion, openContactId, navInfo, navGo }
 * Trang danh sách liên hệ gọi thêm useCrmContactDrawerNav() để popup có nút trước/sau.
 */
const { Provider, useDrawer, useDrawerNav } = createRecordDrawer({
  param: 'contactId',
  kind: 'contact',
  Drawer: CrmContactDrawer,
  names: { open: 'openContact', close: 'closeContact', openId: 'openContactId' },
});

export const CrmContactDrawerProvider = Provider;
export const useCrmContactDrawer = useDrawer;
export const useCrmContactDrawerNav = useDrawerNav;
